
import eService from "../services/eServiceDataService";

export default {
  name: 'Menu',
  data () {
    return {
      menu : [],
      pages : [],
      lang : "en",
      tips : {
        name : "",
        url : ""
      }
    }
  },
  computed: {

  },
  watch: {
    '$store.state.language': function() {
      this.lang = this.$store.state.language;
      this.updatePages();
    }
  },
  methods: {
    async updatePages(){

      var pageArr = [];

      await eService.getManulifePages().then(res => {
        console.log(res);
        pageArr =  res;
      })

      localStorage.setItem("pages", JSON.stringify(pageArr));
      console.log( ( JSON.parse(localStorage.getItem('pages')) ) );

      this.menu = [];
      (pageArr).forEach( (ele) => {
        if(this.lang === "en"){
          (this.menu).push({ name : ele.name_en, route : ele.route });
        } else {
          (this.menu).push({ name : ele.name_zh, route : ele.route });
        }
        if(ele.route === "tips"){
          this.tips.name = ele["name_"+this.lang];
          this.tips.url  = ele["remarks_"+this.lang];
        }
      });
      //console.log(this.menu);
    },
    clickTips(){
      window.open(
          this.tips.url,
          '_blank'
      );
    }
  },
  created: async function () {
      this.updatePages();
  }
}
